import * as React from 'react'

import { cn } from '../lib/cn'

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot='skeleton'
    className={cn('animate-pulse rounded-xl bg-muted-foreground/5 border border-muted', className)}
    {...props}
  />
))
Skeleton.displayName = 'Skeleton'

export { Skeleton }
